import { createSlice } from '@reduxjs/toolkit';
import { getFromLocalStorage, setToLocalStorage } from '../../utils/localStorage';
import { normalizeLanguage } from '../../constants/appConstants';

const STORAGE_KEY = 'language';

const initialState = {
  language: normalizeLanguage(getFromLocalStorage(STORAGE_KEY)),
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      const next = normalizeLanguage(action.payload);
      state.language = next;
      setToLocalStorage(STORAGE_KEY, next);
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export const selectLanguage = (state) => state.language.language;
export default languageSlice.reducer;
